import { baseFetch } from "@helium10/re-core";
import { segmentEventLink } from "../consts/constants";
export const sendSegmentEvent = (data) => {
    // url: testDomain + segmentEventLink,
    return baseFetch({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        url: segmentEventLink,
        params: {
            name: data.name,
            properties: data?.properties,
        },
    });
};
